module.exports = __webpack_public_path__ + "img/photo_girl.98d487c9.png";